import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Image from 'next/image';

export type SlotItem = {
  iconUrl?: string;
  text: string;
};

type SlotTextSwitcherProps = {
  items: SlotItem[];
};

export function SlotTextSwitcher({ items }: SlotTextSwitcherProps) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % items.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [items]);

  const currentItem = items[index];

  return (
    <div className="flex w-full items-center justify-center space-x-3 overflow-hidden text-sm font-semibold">
      <AnimatePresence mode="wait">
        <motion.div
          key={index}
          initial={{ y: '10%', opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: '-10%', opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="flex items-center justify-center space-x-2"
        >
          {currentItem.iconUrl && (
            <Image
              src={currentItem.iconUrl}
              alt=""
              width={8}
              height={8}
              className="h-4 w-4 sm:h-4 sm:w-4"
            />
          )}
          <span>{currentItem.text}</span>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
